export enum WorkReportCategory {
    IncidentNotification = 'incidentNotification',
    EndShift = 'endShift'
}